import * as React from "react";
import { 
  OtpValidateEmail
} from "@njoy/controller";
import { validateOTPSchema } from "@njoy/common";
import { Field, Form, Formik } from "formik";
import { Form as AntForm } from "antd";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { SuccessModal } from "../../../../../components/modals/sucessModal"
import { TemplateSub } from "../../../../../components/layouts/TemplateSub";
import NewButton from "../../../../../components/uiMerge/newButton"
import { InputOTPField } from "../../../../shared/InputOTPField"
import { useState } from "react";
import * as ROUTES from "../../../../../constants/routes";
import ToastMessage from "../../../../../hooks/useToast";
import { extractError } from "../../../../../utils/extractError";


const FormItem = AntForm.Item;

export interface OTPValidateFormValues {
  verificationCode: string;
}

function normalizeErrors(errors: { path: string; message: string }[]): Record<string, string> {
  const errMap: Record<string, string> = {};
  errors.forEach(e => {
    if (e && e.path) {
      errMap[e.path] = e.message;
    }
  });
  return errMap;
}

export const ChangeEmailOtpPage: React.FC = () => {
  const [email, setEmail] = useState<string>("")
  const [visible, isVisible] = useState(false);

  const onFinish = () => {
    window.location.replace(ROUTES.ACCOUNT_DETAILS);
  };

  React.useEffect(() => {
   const foundEmail = localStorage.getItem('email');
   setEmail(foundEmail || "");
  }, []);


  return (
    <OtpValidateEmail>
      {({ otpEmailValidate }) => (
        <Formik<OTPValidateFormValues>
          validationSchema={validateOTPSchema}
          validateOnChange={true}
          validateOnBlur={true}
          initialValues={{
            verificationCode: "",
          }}
          onSubmit={async (
            { verificationCode }, 
            { resetForm, setSubmitting, setErrors, setValues }
          ) => {
            const response:any = await otpEmailValidate({ variables: { verificationCode, email } });
            setSubmitting(false);
            resetForm();
            verificationCode = "";
            setValues({ verificationCode: ""});

            if (!response || !response.data) {
              setErrors({ verificationCode: "No response from server. Please try again." });
              ToastMessage("error", "No response from server. Please try again.");
              return;
            }
         
            const result = response.data.otpValidateEmail;

            if (result?.errors && result.errors.length > 0) {
              const errorMap = normalizeErrors(result.errors);
              setErrors(errorMap);
              ToastMessage("error", extractError(errorMap));
              return;
            }
            
            if (result?.message) {
              ToastMessage("success", result.message);
              isVisible(true);
            }
          }}
        >
          {({ isSubmitting }) => (
            <TemplateSub page={"Enter OTP"}>
              <ToastContainer />

              <div className="mt-8 mb-2 w-full flex-1 flex flex-col">
                <p className="px-[3rem] text-[16px] py-10 text-center text-white">
                  We sent an OTP to <span className="font-bold">{email}</span>. 
                  Enter it below to continue.
                </p>
              
                <Form className="flex flex-col px-[1rem] flex-1">
                  <Field
                    name="verificationCode"
                    component={InputOTPField}
                    otpLength={4}
                  />

                  <div className="mt-auto ">
                    <FormItem>
                      <NewButton
                        loading={isSubmitting}
                        fullWidth
                        variant="primary"
                        type="submit"
                        // onClick={() => isVisible(true)}
                      >
                        Done
                      </NewButton>
                    </FormItem>
                  </div>
                </Form>
                <SuccessModal
                  visible={visible}
                  onCancel={() => isVisible(false)}
                  caption="Your email address has been changed successfully."
                  onClick={() => {
                    isVisible(false);
                    // window.location.replace(ROUTES.ACCOUNT_DETAILS);

                    onFinish();
                  }}
                />
              </div>
            </TemplateSub>
          )}
        </Formik>
      )}
    </OtpValidateEmail>
  );
};